(() => {
  const initialize = (root) => {
    if (!root || root.dataset.instagramReady === "true") return;
    root.dataset.instagramReady = "true";

    const dialog = root.querySelector("[data-towa-instagram-dialog]");
    const frame = root.querySelector("[data-towa-instagram-frame]");
    const original = root.querySelector("[data-towa-instagram-original]");
    const close = root.querySelector("[data-towa-instagram-close]");
    if (!dialog || !frame || !original || !close) return;

    const stopVideo = () => frame.removeAttribute("src");
    const closeDialog = () => {
      if (typeof dialog.close === "function") dialog.close();
      else dialog.removeAttribute("open");
      stopVideo();
    };

    root.querySelectorAll("[data-towa-instagram-open]").forEach((button) => {
      button.addEventListener("click", () => {
        frame.title = button.dataset.embedTitle || "Instagram動画";
        frame.src = button.dataset.embedUrl;
        original.href = button.dataset.postUrl;
        if (typeof dialog.showModal === "function") dialog.showModal();
        else dialog.setAttribute("open", "");
        close.focus({ preventScroll: true });
      });
    });

    close.addEventListener("click", closeDialog);
    dialog.addEventListener("close", stopVideo);
    dialog.addEventListener("click", (event) => {
      if (event.target === dialog) closeDialog();
    });
  };

  const initializeAll = (scope = document) =>
    scope.querySelectorAll("[data-towa-instagram]").forEach(initialize);

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  else initializeAll();

  document.addEventListener("shopify:section:load", (event) =>
    initializeAll(event.target),
  );
})();
